import { useData } from "./DataContext.js";

import ProgressBar from "react-bootstrap/ProgressBar";

export default function ScoreFormat (props)
{
    const gData = useData();

    let variant = "success";
    if (gData.state.score <= 33) variant = "danger";
    else if (gData.state.score <= 66) variant = "warning";
    
    return (
	<div className="w-100 d-flex align-items-top gap-3">
	    <span className="d-flex flex-column align-items-start gap-0">
		<span className="fs-6 text-light" style={{ textShadow: "#AAF 1px 1px 10px" }}>Cybersécurité du laboratoire</span>
		<ProgressBar className="w-100 border border-light">
		    <ProgressBar striped variant={variant} now={gData.state.score} key={1}/>
		    <ProgressBar variant="light" now={100-gData.state.score} key={2}/>
		</ProgressBar>
	    </span>
	    <div className="fs-2 text-light" style={{ textShadow: "#AAF 1px 1px 10px" }}>{gData.state.score}%</div>
	</div>
    );
}
